import "./styles.css";
import logo from "../../assets/loader.png";
function Loader2() {
  return (
    <div className="w-full h-screen flex justify-center items-center bg-white">
      <img src={logo} alt="loader" className="w-72 animate-bounce" />
    </div>
  );
}

export default Loader2;
